<template>
  <div class="home">
    <div class="md-layout welcome">
      <div class=" md-layout welcome-content-image">
        <div class="kab-20-home">
          <img
            class="kabs-gif"
            :src="require('@/assets/kab20-gif.gif')"
          >
        </div>
      </div>
    </div>
    <div class="md-layout home-exhibitors">
      <div class="md-layout home-content-image"> 
        <div class="home-content">
          <exhibitors />
        </div>
      </div>
    </div>
    <div>
      <kab-subscribe>
        <template #subscribe-content>
          <subscribe />
        </template>
      </kab-subscribe>
    </div>
  </div>
</template>

<script>
import Welcome from "@/components/Welcome"
import Exhibitors from "@/components/Exhibitors"
import KabSubscribe from "@/components/KabSubscribe"
import Subscribe from "@/components/Subscribe"
export default {
  name: "Home",
  components: {
    Exhibitors,
    KabSubscribe,
    Subscribe
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home-content {
  margin: -25px 13% auto 13%;
}
.welcome{
  height: 100vh !important;
}
.home-exhibitors {
  position: relative;
  margin-top: 262px;
  min-height: 51px; 
  object-fit: contain;
  background-blend-mode: multiply;
  background-image: linear-gradient(to left, #6a0043, #b42476);
  border-top-left-radius: 81px;
  border-top-right-radius: 81px;

  .home-content-image {
    background: url('../assets/scan-text-2@2x.png');
    background-size: cover;
  }
}
.kab-20-home { 
  width: 100%;
  height: 100vh;
  object-fit: contain;
  opacity: 0.8;
  background-color: #000000;
  .map {
    img {
      position: relative;
      top: 20%;
      left: 10%;
    }
  }
  .kabs-gif {
    width: 80%;
    height: 80%;
  }
}
@media only screen and (max-width: 600px) {
  .kab-20-home { 
    .kabs-gif {
      width: 100vw;
      height: 40%;
      position: relative;
      top: 120px
    }
  }
}
</style>
